webpackJsonp([5353415718535],{

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _helpers = __webpack_require__(35);
	
	var _Paper = _interopRequireDefault(__webpack_require__(78));
	
	// @inheritedComponent Paper
	var styles = function styles(theme) {
	  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: 'column',
	      width: '100%',
	      boxSizing: 'border-box',
	      // Prevent padding issue with the Modal and fixed positioned AppBar.
	      zIndex: theme.zIndex.appBar,
	      flexShrink: 0
	    },
	    positionFixed: {
	      position: 'fixed',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionAbsolute: {
	      position: 'absolute',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionSticky: {
	      position: 'sticky',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionStatic: {
	      position: 'static'
	    },
	    colorDefault: {
	      backgroundColor: backgroundColorDefault,
	      color: theme.palette.getContrastText(backgroundColorDefault)
	    },
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    }
	  };
	};
	
	exports.styles = styles;
	
	function AppBar(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      position = props.position,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "position"]);
	  var className = (0, _classnames.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, 'mui-fixed', position === 'fixed'), _classNames), classNameProp);
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    component: "header",
	    elevation: 4,
	    className: className
	  }, other), children);
	}
	
	AppBar.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'default']),
	
	  /**
	   * The positioning type. The behavior of the different options is described
	   * [here](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
	   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
	   */
	  position: _propTypes.default.oneOf(['fixed', 'absolute', 'sticky', 'static'])
	} : {};
	AppBar.defaultProps = {
	  color: 'primary',
	  position: 'fixed'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAppBar'
	})(AppBar);
	
	exports.default = _default;

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	
	var _AppBar = _interopRequireDefault(__webpack_require__(154));

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var styles = function styles(theme) {
	  return {
	    root: (0, _objectSpread2.default)({}, theme.mixins.toolbar, {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center'
	    }),
	    gutters: theme.mixins.gutters()
	  };
	};
	
	exports.styles = styles;
	
	function Toolbar(props) {
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      disableGutters = props.disableGutters,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableGutters"]);
	  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.gutters, !disableGutters), classNameProp);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: className
	  }, other), children);
	}
	
	Toolbar.propTypes =  false ? {
	  /**
	   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, disables gutter padding.
	   */
	  disableGutters: _propTypes.default.bool
	} : {};
	Toolbar.defaultProps = {
	  disableGutters: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiToolbar'
	})(Toolbar);
	
	exports.default = _default;

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.default;
	  }
	});
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(261));

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  ZERO: 48,
	  NINE: 57,
	
	  NUMPAD_ZERO: 96,
	  NUMPAD_NINE: 105,
	
	  BACKSPACE: 8,
	  DELETE: 46,
	  ENTER: 13,
	
	  ARROW_UP: 38,
	  ARROW_DOWN: 40
	};
	module.exports = exports['default'];

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(23);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(26);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(30);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(29);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KeyCode = __webpack_require__(146);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Options = function (_React$Component) {
	  (0, _inherits3['default'])(Options, _React$Component);
	
	  function Options(props) {
	    (0, _classCallCheck3['default'])(this, Options);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Options.__proto__ || Object.getPrototypeOf(Options)).call(this, props));
	
	    _this.buildOptionText = function (value) {
	      return value + ' ' + _this.props.locale.items_per_page;
	    };
	
	    _this.changeSize = function (value) {
	      _this.props.changeSize(Number(value));
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState({
	        goInputText: e.target.value
	      });
	    };
	
	    _this.go = function (e) {
	      var val = _this.state.goInputText;
	      if (val === '') {
	        return;
	      }
	      val = isNaN(val) ? _this.props.current : Number(val);
	      if (e.keyCode === _KeyCode2['default'].ENTER || e.type === 'click') {
	        _this.setState({
	          goInputText: ''
	        });
	        _this.props.quickGo(val);
	      }
	    };
	
	    _this.state = {
	      goInputText: ''
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Options, [{
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      var state = this.state;
	      var locale = props.locale;
	      var prefixCls = props.rootPrefixCls + '-options';
	      var changeSize = props.changeSize;
	      var quickGo = props.quickGo;
	      var goButton = props.goButton;
	      var buildOptionText = props.buildOptionText || this.buildOptionText;
	      var Select = props.selectComponentClass;
	      var changeSelect = null;
	      var goInput = null;
	      var gotoButton = null;
	
	      if (!(changeSize || quickGo)) {
	        return null;
	      }
	
	      if (changeSize && Select) {
	        var Option = Select.Option;
	        var pageSize = props.pageSize || props.pageSizeOptions[0];
	        var options = props.pageSizeOptions.map(function (opt, i) {
	          return _react2['default'].createElement(
	            Option,
	            { key: i, value: opt },
	            buildOptionText(opt)
	          );
	        });
	
	        changeSelect = _react2['default'].createElement(
	          Select,
	          {
	            prefixCls: props.selectPrefixCls,
	            showSearch: false,
	            className: prefixCls + '-size-changer',
	            optionLabelProp: 'children',
	            dropdownMatchSelectWidth: false,
	            value: pageSize.toString(),
	            onChange: this.changeSize,
	            getPopupContainer: function getPopupContainer(triggerNode) {
	              return triggerNode.parentNode;
	            }
	          },
	          options
	        );
	      }
	
	      if (quickGo) {
	        if (goButton) {
	          if (typeof goButton === 'boolean') {
	            gotoButton = _react2['default'].createElement(
	              'button',
	              {
	                type: 'button',
	                onClick: this.go,
	                onKeyUp: this.go
	              },
	              locale.jump_to_confirm
	            );
	          } else {
	            gotoButton = _react2['default'].createElement(
	              'span',
	              {
	                onClick: this.go,
	                onKeyUp: this.go
	              },
	              goButton
	            );
	          }
	        }
	        goInput = _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-quick-jumper' },
	          locale.jump_to,
	          _react2['default'].createElement('input', {
	            type: 'text',
	            value: state.goInputText,
	            onChange: this.handleChange,
	            onKeyUp: this.go
	          }),
	          locale.page,
	          gotoButton
	        );
	      }
	
	      return _react2['default'].createElement(
	        'li',
	        { className: '' + prefixCls },
	        changeSelect,
	        goInput
	      );
	    }
	  }]);
	  return Options;
	}(_react2['default'].Component);
	
	Options.propTypes = {
	  changeSize: _propTypes2['default'].func,
	  quickGo: _propTypes2['default'].func,
	  selectComponentClass: _propTypes2['default'].func,
	  current: _propTypes2['default'].number,
	  pageSizeOptions: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  pageSize: _propTypes2['default'].number,
	  buildOptionText: _propTypes2['default'].func,
	  locale: _propTypes2['default'].object
	};
	Options.defaultProps = {
	  pageSizeOptions: ['10', '20', '30', '40']
	};
	exports['default'] = Options;
	module.exports = exports['default'];

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Pager = function Pager(props) {
	  var prefixCls = props.rootPrefixCls + '-item';
	  var cls = prefixCls + ' ' + prefixCls + '-' + props.page;
	
	  if (props.active) {
	    cls = cls + ' ' + prefixCls + '-active';
	  }
	
	  if (props.className) {
	    cls = cls + ' ' + props.className;
	  }
	
	  var handleClick = function handleClick() {
	    props.onClick(props.page);
	  };
	
	  var handleKeyPress = function handleKeyPress(e) {
	    props.onKeyPress(e, props.onClick, props.page);
	  };
	
	  return _react2['default'].createElement(
	    'li',
	    {
	      title: props.showTitle ? props.page : null,
	      className: cls,
	      onClick: handleClick,
	      onKeyPress: handleKeyPress,
	      tabIndex: '0'
	    },
	    props.itemRender(props.page, 'page', _react2['default'].createElement(
	      'a',
	      null,
	      props.page
	    ))
	  );
	};
	
	Pager.propTypes = {
	  page: _propTypes2['default'].number,
	  active: _propTypes2['default'].bool,
	  last: _propTypes2['default'].bool,
	  locale: _propTypes2['default'].object,
	  className: _propTypes2['default'].string,
	  showTitle: _propTypes2['default'].bool,
	  rootPrefixCls: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  onKeyPress: _propTypes2['default'].func,
	  itemRender: _propTypes2['default'].func
	};
	
	exports['default'] = Pager;
	module.exports = exports['default'];

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(23);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(26);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(30);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(29);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Pager = __webpack_require__(342);
	
	var _Pager2 = _interopRequireDefault(_Pager);
	
	var _Options = __webpack_require__(341);
	
	var _Options2 = _interopRequireDefault(_Options);
	
	var _KeyCode = __webpack_require__(146);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _zh_CN = __webpack_require__(345);
	
	var _zh_CN2 = _interopRequireDefault(_zh_CN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function isInteger(value) {
	  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	}
	
	function defaultItemRender(page, type, element) {
	  return element;
	}
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3['default'])(Pagination, _React$Component);
	
	  function Pagination(props) {
	    (0, _classCallCheck3['default'])(this, Pagination);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var hasOnChange = props.onChange !== noop;
	    var hasCurrent = 'current' in props;
	    if (hasCurrent && !hasOnChange) {
	      console.warn('Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.'); // eslint-disable-line
	    }
	
	    var current = props.defaultCurrent;
	    if ('current' in props) {
	      current = props.current;
	    }
	
	    var pageSize = props.defaultPageSize;
	    if ('pageSize' in props) {
	      pageSize = props.pageSize;
	    }
	
	    _this.state = {
	      current: current,
	      currentInputValue: current,
	      pageSize: pageSize
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Pagination, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ('current' in nextProps) {
	        this.setState({
	          current: nextProps.current,
	          currentInputValue: nextProps.current
	        });
	      }
	
	      if ('pageSize' in nextProps) {
	        var newState = {};
	        var current = this.state.current;
	        var newCurrent = this.calculatePage(nextProps.pageSize);
	        current = current > newCurrent ? newCurrent : current;
	        if (!('current' in nextProps)) {
	          newState.current = current;
	          newState.currentInputValue = current;
	        }
	        newState.pageSize = nextProps.pageSize;
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // When current page change, fix focused style of prev item
	      // A hacky solution of https://github.com/ant-design/ant-design/issues/8948
	      var prefixCls = this.props.prefixCls;
	
	      if (prevState.current !== this.state.current && this.paginationNode) {
	        var lastCurrentNode = this.paginationNode.querySelector('.' + prefixCls + '-item-' + prevState.current);
	        if (lastCurrentNode && document.activeElement === lastCurrentNode) {
	          lastCurrentNode.blur();
	        }
	      }
	    }
	  }, {
	    key: 'getJumpPrevPage',
	    value: function getJumpPrevPage() {
	      return Math.max(1, this.state.current - (this.props.showLessItems ? 3 : 5));
	    }
	  }, {
	    key: 'getJumpNextPage',
	    value: function getJumpNextPage() {
	      return Math.min(this.calculatePage(), this.state.current + (this.props.showLessItems ? 3 : 5));
	    }
	  }, {
	    key: 'getJumpPrevPage',
	    value: function getJumpPrevPage() {
	      return Math.max(1, this.state.current - (this.props.showLessItems ? 3 : 5));
	    }
	  }, {
	    key: 'getJumpNextPage',
	    value: function getJumpNextPage() {
	      return Math.min(this.calculatePage(), this.state.current + (this.props.showLessItems ? 3 : 5));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // When hideOnSinglePage is true and there is only 1 page, hide the pager
	      if (this.props.hideOnSinglePage === true && this.props.total <= this.state.pageSize) {
	        return null;
	      }
	
	      var props = this.props;
	      var locale = props.locale;
	
	      var prefixCls = props.prefixCls;
	      var allPages = this.calculatePage();
	      var pagerList = [];
	      var jumpPrev = null;
	      var jumpNext = null;
	      var firstPager = null;
	      var lastPager = null;
	      var gotoButton = null;
	
	      var goButton = props.showQuickJumper && props.showQuickJumper.goButton;
	      var pageBufferSize = props.showLessItems ? 1 : 2;
	      var _state = this.state,
	          current = _state.current,
	          pageSize = _state.pageSize;
	
	
	      var prevPage = current - 1 > 0 ? current - 1 : 0;
	      var nextPage = current + 1 < allPages ? current + 1 : allPages;
	
	      if (props.simple) {
	        if (goButton) {
	          if (typeof goButton === 'boolean') {
	            gotoButton = _react2['default'].createElement(
	              'button',
	              {
	                type: 'button',
	                onClick: this.handleGoTO,
	                onKeyUp: this.handleGoTO
	              },
	              locale.jump_to_confirm
	            );
	          } else {
	            gotoButton = _react2['default'].createElement(
	              'span',
	              {
	                onClick: this.handleGoTO,
	                onKeyUp: this.handleGoTO
	              },
	              goButton
	            );
	          }
	          gotoButton = _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? '' + locale.jump_to + this.state.current + '/' + allPages : null,
	              className: prefixCls + '-simple-pager'
	            },
	            gotoButton
	          );
	        }
	
	        return _react2['default'].createElement(
	          'ul',
	          { className: prefixCls + ' ' + prefixCls + '-simple ' + props.className, style: props.style },
	          _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? locale.prev_page : null,
	              onClick: this.prev,
	              tabIndex: this.hasPrev() ? 0 : null,
	              onKeyPress: this.runIfEnterPrev,
	              className: (this.hasPrev() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
	              'aria-disabled': !this.hasPrev()
	            },
	            props.itemRender(prevPage, 'prev', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	          ),
	          _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? this.state.current + '/' + allPages : null,
	              className: prefixCls + '-simple-pager'
	            },
	            _react2['default'].createElement('input', {
	              type: 'text',
	              value: this.state.currentInputValue,
	              onKeyDown: this.handleKeyDown,
	              onKeyUp: this.handleKeyUp,
	              onChange: this.handleKeyUp,
	              size: '3'
	            }),
	            _react2['default'].createElement(
	              'span',
	              { className: prefixCls + '-slash' },
	              '\uFF0F'
	            ),
	            allPages
	          ),
	          _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? locale.next_page : null,
	              onClick: this.next,
	              tabIndex: this.hasPrev() ? 0 : null,
	              onKeyPress: this.runIfEnterNext,
	              className: (this.hasNext() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
	              'aria-disabled': !this.hasNext()
	            },
	            props.itemRender(nextPage, 'next', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	          ),
	          gotoButton
	        );
	      }
	
	      if (allPages <= 5 + pageBufferSize * 2) {
	        for (var i = 1; i <= allPages; i++) {
	          var active = this.state.current === i;
	          pagerList.push(_react2['default'].createElement(_Pager2['default'], {
	            locale: locale,
	            rootPrefixCls: prefixCls,
	            onClick: this.handleChange,
	            onKeyPress: this.runIfEnter,
	            key: i,
	            page: i,
	            active: active,
	            showTitle: props.showTitle,
	            itemRender: props.itemRender
	          }));
	        }
	      } else {
	        var prevItemTitle = props.showLessItems ? locale.prev_3 : locale.prev_5;
	        var nextItemTitle = props.showLessItems ? locale.next_3 : locale.next_5;
	        if (props.showPrevNextJumpers) {
	          jumpPrev = _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? prevItemTitle : null,
	              key: 'prev',
	              onClick: this.jumpPrev,
	              tabIndex: '0',
	              onKeyPress: this.runIfEnterJumpPrev,
	              className: prefixCls + '-jump-prev'
	            },
	            props.itemRender(this.getJumpPrevPage(), 'jump-prev', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	          );
	          jumpNext = _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? nextItemTitle : null,
	              key: 'next',
	              tabIndex: '0',
	              onClick: this.jumpNext,
	              onKeyPress: this.runIfEnterJumpNext,
	              className: prefixCls + '-jump-next'
	            },
	            props.itemRender(this.getJumpNextPage(), 'jump-next', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	          );
	        }
	        lastPager = _react2['default'].createElement(_Pager2['default'], {
	          locale: props.locale,
	          last: true,
	          rootPrefixCls: prefixCls,
	          onClick: this.handleChange,
	          onKeyPress: this.runIfEnter,
	          key: allPages,
	          page: allPages,
	          active: false,
	          showTitle: props.showTitle,
	          itemRender: props.itemRender
	        });
	        firstPager = _react2['default'].createElement(_Pager2['default'], {
	          locale: props.locale,
	          rootPrefixCls: prefixCls,
	          onClick: this.handleChange,
	          onKeyPress: this.runIfEnter,
	          key: 1,
	          page: 1,
	          active: false,
	          showTitle: props.showTitle,
	          itemRender: props.itemRender
	        });
	
	        var left = Math.max(1, current - pageBufferSize);
	        var right = Math.min(current + pageBufferSize, allPages);
	
	        if (current - 1 <= pageBufferSize) {
	          right = 1 + pageBufferSize * 2;
	        }
	
	        if (allPages - current <= pageBufferSize) {
	          left = allPages - pageBufferSize * 2;
	        }
	
	        for (var _i = left; _i <= right; _i++) {
	          var _active = current === _i;
	          pagerList.push(_react2['default'].createElement(_Pager2['default'], {
	            locale: props.locale,
	            rootPrefixCls: prefixCls,
	            onClick: this.handleChange,
	            onKeyPress: this.runIfEnter,
	            key: _i,
	            page: _i,
	            active: _active,
	            showTitle: props.showTitle,
	            itemRender: props.itemRender
	          }));
	        }
	
	        if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
	          pagerList[0] = _react2['default'].cloneElement(pagerList[0], {
	            className: prefixCls + '-item-after-jump-prev'
	          });
	          pagerList.unshift(jumpPrev);
	        }
	        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
	          pagerList[pagerList.length - 1] = _react2['default'].cloneElement(pagerList[pagerList.length - 1], {
	            className: prefixCls + '-item-before-jump-next'
	          });
	          pagerList.push(jumpNext);
	        }
	
	        if (left !== 1) {
	          pagerList.unshift(firstPager);
	        }
	        if (right !== allPages) {
	          pagerList.push(lastPager);
	        }
	      }
	
	      var totalText = null;
	
	      if (props.showTotal) {
	        totalText = _react2['default'].createElement(
	          'li',
	          { className: prefixCls + '-total-text' },
	          props.showTotal(props.total, [(current - 1) * pageSize + 1, current * pageSize > props.total ? props.total : current * pageSize])
	        );
	      }
	      var prevDisabled = !this.hasPrev();
	      var nextDisabled = !this.hasNext();
	      return _react2['default'].createElement(
	        'ul',
	        {
	          className: prefixCls + ' ' + props.className,
	          style: props.style,
	          unselectable: 'unselectable',
	          ref: this.savePaginationNode
	        },
	        totalText,
	        _react2['default'].createElement(
	          'li',
	          {
	            title: props.showTitle ? locale.prev_page : null,
	            onClick: this.prev,
	            tabIndex: prevDisabled ? null : 0,
	            onKeyPress: this.runIfEnterPrev,
	            className: (!prevDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
	            'aria-disabled': prevDisabled
	          },
	          props.itemRender(prevPage, 'prev', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	        ),
	        pagerList,
	        _react2['default'].createElement(
	          'li',
	          {
	            title: props.showTitle ? locale.next_page : null,
	            onClick: this.next,
	            tabIndex: nextDisabled ? null : 0,
	            onKeyPress: this.runIfEnterNext,
	            className: (!nextDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
	            'aria-disabled': nextDisabled
	          },
	          props.itemRender(nextPage, 'next', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	        ),
	        _react2['default'].createElement(_Options2['default'], {
	          locale: props.locale,
	          rootPrefixCls: prefixCls,
	          selectComponentClass: props.selectComponentClass,
	          selectPrefixCls: props.selectPrefixCls,
	          changeSize: this.props.showSizeChanger ? this.changePageSize : null,
	          current: this.state.current,
	          pageSize: this.state.pageSize,
	          pageSizeOptions: this.props.pageSizeOptions,
	          quickGo: this.props.showQuickJumper ? this.handleChange : null,
	          goButton: goButton
	        })
	      );
	    }
	  }]);
	  return Pagination;
	}(_react2['default'].Component);
	
	Pagination.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  current: _propTypes2['default'].number,
	  defaultCurrent: _propTypes2['default'].number,
	  total: _propTypes2['default'].number,
	  pageSize: _propTypes2['default'].number,
	  defaultPageSize: _propTypes2['default'].number,
	  onChange: _propTypes2['default'].func,
	  hideOnSinglePage: _propTypes2['default'].bool,
	  showSizeChanger: _propTypes2['default'].bool,
	  showLessItems: _propTypes2['default'].bool,
	  onShowSizeChange: _propTypes2['default'].func,
	  selectComponentClass: _propTypes2['default'].func,
	  showPrevNextJumpers: _propTypes2['default'].bool,
	  showQuickJumper: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].object]),
	  showTitle: _propTypes2['default'].bool,
	  pageSizeOptions: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  showTotal: _propTypes2['default'].func,
	  locale: _propTypes2['default'].object,
	  style: _propTypes2['default'].object,
	  itemRender: _propTypes2['default'].func
	};
	Pagination.defaultProps = {
	  defaultCurrent: 1,
	  total: 0,
	  defaultPageSize: 10,
	  onChange: noop,
	  className: '',
	  selectPrefixCls: 'rc-select',
	  prefixCls: 'rc-pagination',
	  selectComponentClass: null,
	  hideOnSinglePage: false,
	  showPrevNextJumpers: true,
	  showQuickJumper: false,
	  showSizeChanger: false,
	  showLessItems: false,
	  showTitle: true,
	  onShowSizeChange: noop,
	  locale: _zh_CN2['default'],
	  style: {},
	  itemRender: defaultItemRender
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.savePaginationNode = function (node) {
	    _this2.paginationNode = node;
	  };
	
	  this.calculatePage = function (p) {
	    var pageSize = p;
	    if (typeof pageSize === 'undefined') {
	      pageSize = _this2.state.pageSize;
	    }
	    return Math.floor((_this2.props.total - 1) / pageSize) + 1;
	  };
	
	  this.isValid = function (page) {
	    return isInteger(page) && page >= 1 && page !== _this2.state.current;
	  };
	
	  this.handleKeyDown = function (e) {
	    if (e.keyCode === _KeyCode2['default'].ARROW_UP || e.keyCode === _KeyCode2['default'].ARROW_DOWN) {
	      e.preventDefault();
	    }
	  };
	
	  this.handleKeyUp = function (e) {
	    var inputValue = e.target.value;
	    var currentInputValue = _this2.state.currentInputValue;
	    var value = void 0;
	
	    if (inputValue === '') {
	      value = inputValue;
	    } else if (isNaN(Number(inputValue))) {
	      value = currentInputValue;
	    } else {
	      value = Number(inputValue);
	    }
	
	    if (value !== currentInputValue) {
	      _this2.setState({
	        currentInputValue: value
	      });
	    }
	
	    if (e.keyCode === _KeyCode2['default'].ENTER) {
	      _this2.handleChange(value);
	    } else if (e.keyCode === _KeyCode2['default'].ARROW_UP) {
	      _this2.handleChange(value - 1);
	    } else if (e.keyCode === _KeyCode2['default'].ARROW_DOWN) {
	      _this2.handleChange(value + 1);
	    }
	  };
	
	  this.changePageSize = function (size) {
	    var current = _this2.state.current;
	    var newCurrent = _this2.calculatePage(size);
	    current = current > newCurrent ? newCurrent : current;
	    // fix the issue:
	    // Once 'total' is 0, 'current' in 'onShowSizeChange' is 0, which is not correct.
	    if (newCurrent === 0) {
	      current = _this2.state.current;
	    }
	
	    if (typeof size === 'number') {
	      if (!('pageSize' in _this2.props)) {
	        _this2.setState({
	          pageSize: size
	        });
	      }
	      if (!('current' in _this2.props)) {
	        _this2.setState({
	          current: current,
	          currentInputValue: current
	        });
	      }
	    }
	    _this2.props.onShowSizeChange(current, size);
	  };
	
	  this.handleChange = function (p) {
	    var page = p;
	    if (_this2.isValid(page)) {
	      if (page > _this2.calculatePage()) {
	        page = _this2.calculatePage();
	      }
	
	      if (!('current' in _this2.props)) {
	        _this2.setState({
	          current: page,
	          currentInputValue: page
	        });
	      }
	
	      var pageSize = _this2.state.pageSize;
	      _this2.props.onChange(page, pageSize);
	
	      return page;
	    }
	
	    return _this2.state.current;
	  };
	
	  this.prev = function () {
	    if (_this2.hasPrev()) {
	      _this2.handleChange(_this2.state.current - 1);
	    }
	  };
	
	  this.next = function () {
	    if (_this2.hasNext()) {
	      _this2.handleChange(_this2.state.current + 1);
	    }
	  };
	
	  this.jumpPrev = function () {
	    _this2.handleChange(_this2.getJumpPrevPage());
	  };
	
	  this.jumpNext = function () {
	    _this2.handleChange(_this2.getJumpNextPage());
	  };
	
	  this.hasPrev = function () {
	    return _this2.state.current > 1;
	  };
	
	  this.hasNext = function () {
	    return _this2.state.current < _this2.calculatePage();
	  };
	
	  this.runIfEnter = function (event, callback) {
	    for (var _len = arguments.length, restParams = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      restParams[_key - 2] = arguments[_key];
	    }
	
	    if (event.key === 'Enter' || event.charCode === 13) {
	      callback.apply(undefined, restParams);
	    }
	  };
	
	  this.runIfEnterPrev = function (e) {
	    _this2.runIfEnter(e, _this2.prev);
	  };
	
	  this.runIfEnterNext = function (e) {
	    _this2.runIfEnter(e, _this2.next);
	  };
	
	  this.runIfEnterJumpPrev = function (e) {
	    _this2.runIfEnter(e, _this2.jumpPrev);
	  };
	
	  this.runIfEnterJumpNext = function (e) {
	    _this2.runIfEnter(e, _this2.jumpNext);
	  };
	
	  this.handleGoTO = function (e) {
	    if (e.keyCode === _KeyCode2['default'].ENTER || e.type === 'click') {
	      _this2.handleChange(_this2.state.currentInputValue);
	    }
	  };
	};
	
	exports['default'] = Pagination;
	module.exports = exports['default'];

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Pagination = __webpack_require__(343);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pagination)['default'];
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = exports['default'];

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = {
	  // Options.jsx
	  items_per_page: '条/页',
	  jump_to: '跳至',
	  jump_to_confirm: '确定',
	  page: '页',
	
	  // Pagination.jsx
	  prev_page: '上一页',
	  next_page: '下一页',
	  prev_5: '向前 5 页',
	  next_5: '向后 5 页',
	  prev_3: '向前 3 页',
	  next_3: '向后 3 页'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  overlay: {
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    width: '100%',
	    height: '100%',
	    background: 'rgba(22, 22, 22, 0.78)'
	  },
	  contentContainer: {
	    height: '100%',
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  content: {
	    textAlign: 'center'
	  }
	};
	
	var Intro = function Intro(_ref) {
	  var classes = _ref.classes,
	      theme = _ref.theme,
	      wrapperClassName = _ref.wrapperClassName,
	      gatsbyImage = _ref.gatsbyImage,
	      inspirationalQuote = _ref.inspirationalQuote;
	  return _react2.default.createElement(
	    'div',
	    { className: wrapperClassName },
	    gatsbyImage,
	    _react2.default.createElement(
	      'div',
	      { className: classes.overlay },
	      _react2.default.createElement(
	        'div',
	        { className: classes.contentContainer },
	        _react2.default.createElement(
	          'div',
	          { className: classes.content },
	          _react2.default.createElement(
	            _Typography2.default,
	            {
	              variant: 'display3',
	              style: { color: '#fff', fontWeight: 500 }
	            },
	            'REAL'
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            {
	              variant: 'headline',
	              style: { color: theme.palette.text.lighter, fontWeight: 300 },
	              gutterBottom: true
	            },
	            'SUCCESS STORIES'
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            {
	              style: {
	                color: '#fff',
	                fontStyle: 'italic',
	                fontWeight: 300,
	                fontFamily: 'Times',
	                fontSize: '1.2em'
	              }
	            },
	            inspirationalQuote
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(styles, { withTheme: true })(Intro);
	module.exports = exports['default'];

/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var OtherStories = function OtherStories(_ref) {
	  var className = _ref.className,
	      header = _ref.header,
	      inspirationalQuote = _ref.inspirationalQuote,
	      render = _ref.render,
	      props = _objectWithoutProperties(_ref, ['className', 'header', 'inspirationalQuote', 'render']);
	
	  return _react2.default.createElement(
	    _Grid2.default,
	    _extends({
	      spacing: 40,
	      classes: { container: className },
	      justify: 'center',
	      alignItems: 'center'
	    }, props, {
	      container: true
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { xs: 12, item: true },
	      header
	    ),
	    _react2.default.createElement(
	      _Grid2.default,
	      { xs: 12, item: true },
	      inspirationalQuote
	    ),
	    render(Story)
	  );
	};
	
	OtherStories.propTypes = {
	  className: _propTypes2.default.string.isRequired,
	  header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
	  inspirationalQuote: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
	  render: _propTypes2.default.func.isRequired
	};
	
	function Story(_ref2) {
	  var top = _ref2.top,
	      bottom = _ref2.bottom,
	      otherProps = _objectWithoutProperties(_ref2, ['top', 'bottom']);
	
	  return _react2.default.createElement(
	    _Grid2.default,
	    _extends({ xs: 12, sm: 12, md: 4, xl: 3 }, otherProps, { item: true }),
	    top,
	    bottom
	  );
	}
	
	Story.propTypes = {
	  top: _propTypes2.default.node.isRequired,
	  bottom: _propTypes2.default.node.isRequired
	};
	
	exports.default = OtherStories;
	module.exports = exports['default'];

/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OtherStoryExcerpt = function OtherStoryExcerpt(_ref) {
	  var className = _ref.className,
	      text = _ref.text;
	  return _react2.default.createElement(
	    _Typography2.default,
	    { variant: 'body1', classes: { root: className }, gutterBottom: true },
	    text
	  );
	};
	
	OtherStoryExcerpt.propTypes = {
	  className: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired
	};
	
	exports.default = OtherStoryExcerpt;
	module.exports = exports['default'];

/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OtherStoryLearnMoreBtn = function OtherStoryLearnMoreBtn(_ref) {
	  var btnClassName = _ref.btnClassName,
	      url = _ref.url,
	      text = _ref.text;
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: url },
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        size: 'medium',
	        variant: 'raised',
	        color: 'primary',
	        classes: { root: btnClassName }
	      },
	      text
	    )
	  );
	};
	
	OtherStoryLearnMoreBtn.propTypes = {
	  btnClassName: _propTypes2.default.string.isRequired,
	  url: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired
	};
	
	exports.default = OtherStoryLearnMoreBtn;
	module.exports = exports['default'];

/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OtherStoryTitle = function OtherStoryTitle(_ref) {
	  var className = _ref.className,
	      text = _ref.text;
	  return _react2.default.createElement(
	    _Typography2.default,
	    { variant: 'headline', classes: { root: className }, gutterBottom: true },
	    text
	  );
	};
	
	OtherStoryTitle.propTypes = {
	  className: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired
	};
	
	exports.default = OtherStoryTitle;
	module.exports = exports['default'];

/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _AppBar = __webpack_require__(155);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	var _Toolbar = __webpack_require__(262);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _rcPagination = __webpack_require__(344);
	
	var _rcPagination2 = _interopRequireDefault(_rcPagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  return {
	    appBar: {
	      background: 'none',
	      boxShadow: 'none'
	    },
	    pagination: {
	      '& > li': {
	        marginBottom: 3,
	        border: '1px solid ' + theme.palette.borders.cloudier,
	        borderRadius: '50%',
	        background: theme.palette.primary.main,
	        transition: 'background 0.5s',
	        '&:hover': {
	          background: theme.palette.background.light
	        },
	        '& > a': {
	          transition: 'color 0.5s',
	          color: '#fff',
	          '&:hover': {
	            color: theme.palette.primary.main
	          }
	        }
	      }
	    }
	  };
	};
	
	var StoriesPagination = function (_React$Component) {
	  _inherits(StoriesPagination, _React$Component);
	
	  function StoriesPagination() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StoriesPagination);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onPageChange = function (current) {
	      var prefix = _this.props.prefix;
	
	      var baseUrl = (0, _gatsbyLink.withPrefix)(prefix);
	      (0, _gatsbyLink.navigateTo)(baseUrl + '/' + (current !== 1 ? current : ''));
	    }, _this.itemRenderer = function (current, type) {
	      var _this$props = _this.props,
	          prefix = _this$props.prefix,
	          currentPage = _this$props.currentPage;
	
	      if (type === 'prev') {
	        return _react2.default.createElement(_gatsbyLink2.default, { to: prefix + '/' + current });
	      }
	      if (type === 'page') {
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: prefix + '/' + current,
	            style: {
	              color: currentPage === current ? '#ffa800' : '#fff'
	            }
	          },
	          current
	        );
	      }
	      if (type === 'next') {
	        return _react2.default.createElement(_gatsbyLink2.default, { to: prefix + '/' + current });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StoriesPagination.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        currentPage = _props.currentPage,
	        totalItems = _props.totalItems,
	        itemsPerPage = _props.itemsPerPage;
	
	    return _react2.default.createElement(
	      _AppBar2.default,
	      { position: 'static', classes: { root: classes.appBar } },
	      _react2.default.createElement(
	        _Toolbar2.default,
	        { style: { margin: 'auto' } },
	        _react2.default.createElement(_rcPagination2.default, {
	          locale: { locale: 'en_US' },
	          current: currentPage,
	          total: totalItems,
	          pageSize: itemsPerPage,
	          pageSizeOptions: ['6', '12', '24', '48'],
	          onChange: this.onPageChange,
	          className: classes.pagination,
	          itemRender: this.itemRenderer
	        })
	      )
	    );
	  };
	
	  return StoriesPagination;
	}(_react2.default.Component);
	
	StoriesPagination.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  currentPage: _propTypes2.default.number.isRequired,
	  totalItems: _propTypes2.default.number.isRequired,
	  itemsPerPage: _propTypes2.default.number.isRequired,
	  prefix: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles)(StoriesPagination);
	module.exports = exports['default'];

/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var StoryOne = function StoryOne(_ref) {
	  var className = _ref.className,
	      leftClassName = _ref.leftClassName,
	      rightClassName = _ref.rightClassName,
	      left = _ref.left,
	      right = _ref.right,
	      props = _objectWithoutProperties(_ref, ['className', 'leftClassName', 'rightClassName', 'left', 'right']);
	
	  return _react2.default.createElement(
	    _Grid2.default,
	    _extends({
	      spacing: 8,
	      classes: { container: className },
	      justify: 'center',
	      alignItems: 'center'
	    }, props, {
	      container: true
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { classes: { item: leftClassName }, item: true },
	      left
	    ),
	    _react2.default.createElement(
	      _Grid2.default,
	      { classes: { item: rightClassName }, item: true },
	      right
	    )
	  );
	};
	
	StoryOne.propTypes = {
	  className: _propTypes2.default.string.isRequired,
	  leftClassName: _propTypes2.default.string.isRequired,
	  rightClassName: _propTypes2.default.string.isRequired,
	  left: _propTypes2.default.node.isRequired,
	  right: _propTypes2.default.node.isRequired
	};
	
	exports.default = StoryOne;
	module.exports = exports['default'];

/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StoryOneExcerpt = function StoryOneExcerpt(_ref) {
	  var className = _ref.className,
	      text = _ref.text;
	  return _react2.default.createElement(
	    _Typography2.default,
	    { variant: 'body1', classes: { root: className }, gutterBottom: true },
	    text
	  );
	};
	
	StoryOneExcerpt.propTypes = {
	  className: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired
	};
	
	exports.default = StoryOneExcerpt;
	module.exports = exports['default'];

/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StoryOneLearnMoreBtn = function StoryOneLearnMoreBtn(_ref) {
	  var btnClassName = _ref.btnClassName,
	      url = _ref.url,
	      text = _ref.text;
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: url },
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        size: 'medium',
	        variant: 'raised',
	        color: 'primary',
	        classes: { root: btnClassName }
	      },
	      text
	    )
	  );
	};
	
	StoryOneLearnMoreBtn.propTypes = {
	  btnClassName: _propTypes2.default.string.isRequired,
	  url: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired
	};
	
	exports.default = StoryOneLearnMoreBtn;
	module.exports = exports['default'];

/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StoryOneTitle = function StoryOneTitle(_ref) {
	  var className = _ref.className,
	      text = _ref.text;
	  return _react2.default.createElement(
	    _Typography2.default,
	    { variant: 'headline', classes: { root: className }, gutterBottom: true },
	    text
	  );
	};
	
	StoryOneTitle.propTypes = {
	  className: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired
	};
	
	exports.default = StoryOneTitle;
	module.exports = exports['default'];

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var StoryTwo = function StoryTwo(_ref) {
	  var className = _ref.className,
	      rightClassName = _ref.rightClassName,
	      leftClassName = _ref.leftClassName,
	      left = _ref.left,
	      right = _ref.right,
	      props = _objectWithoutProperties(_ref, ['className', 'rightClassName', 'leftClassName', 'left', 'right']);
	
	  return _react2.default.createElement(
	    _Grid2.default,
	    _extends({
	      spacing: 8,
	      classes: { container: className },
	      justify: 'center',
	      alignItems: 'center'
	    }, props, {
	      container: true
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { classes: { item: rightClassName }, item: true },
	      right
	    ),
	    _react2.default.createElement(
	      _Grid2.default,
	      { classes: { item: leftClassName }, item: true },
	      left
	    )
	  );
	};
	
	StoryTwo.propTypes = {
	  className: _propTypes2.default.string.isRequired,
	  leftClassName: _propTypes2.default.string.isRequired,
	  rightClassName: _propTypes2.default.string.isRequired,
	  style: _propTypes2.default.object.isRequired,
	  left: _propTypes2.default.node.isRequired,
	  right: _propTypes2.default.node.isRequired
	};
	
	exports.default = StoryTwo;
	module.exports = exports['default'];

/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StoryTwoExcerpt = function StoryTwoExcerpt(_ref) {
	  var className = _ref.className,
	      text = _ref.text;
	  return _react2.default.createElement(
	    _Typography2.default,
	    { variant: 'body1', classes: { root: className }, gutterBottom: true },
	    text
	  );
	};
	
	StoryTwoExcerpt.propTypes = {
	  className: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired
	};
	
	exports.default = StoryTwoExcerpt;
	module.exports = exports['default'];

/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StoryTwoLearnMoreBtn = function StoryTwoLearnMoreBtn(_ref) {
	  var btnClassName = _ref.btnClassName,
	      url = _ref.url,
	      text = _ref.text;
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: url },
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        size: 'medium',
	        variant: 'raised',
	        color: 'primary',
	        classes: { root: btnClassName }
	      },
	      text
	    )
	  );
	};
	
	StoryTwoLearnMoreBtn.propTypes = {
	  btnClassName: _propTypes2.default.string.isRequired,
	  url: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired
	};
	
	exports.default = StoryTwoLearnMoreBtn;
	module.exports = exports['default'];

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StoryTwoTitle = function StoryTwoTitle(_ref) {
	  var className = _ref.className,
	      text = _ref.text;
	  return _react2.default.createElement(
	    _Typography2.default,
	    { variant: 'headline', classes: { root: className }, gutterBottom: true },
	    text
	  );
	};
	
	StoryTwoTitle.propTypes = {
	  className: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired
	};
	
	exports.default = StoryTwoTitle;
	module.exports = exports['default'];

/***/ }),

/***/ 991:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(145);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactLazyload = __webpack_require__(348);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	var _gatsbyImage = __webpack_require__(382);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Meta = __webpack_require__(48);
	
	var _Intro = __webpack_require__(940);
	
	var _Intro2 = _interopRequireDefault(_Intro);
	
	var _StoryOne = __webpack_require__(946);
	
	var _StoryOne2 = _interopRequireDefault(_StoryOne);
	
	var _StoryOneTitle = __webpack_require__(949);
	
	var _StoryOneTitle2 = _interopRequireDefault(_StoryOneTitle);
	
	var _StoryOneExcerpt = __webpack_require__(947);
	
	var _StoryOneExcerpt2 = _interopRequireDefault(_StoryOneExcerpt);
	
	var _StoryOneLearnMoreBtn = __webpack_require__(948);
	
	var _StoryOneLearnMoreBtn2 = _interopRequireDefault(_StoryOneLearnMoreBtn);
	
	var _StoryTwo = __webpack_require__(950);
	
	var _StoryTwo2 = _interopRequireDefault(_StoryTwo);
	
	var _StoryTwoTitle = __webpack_require__(953);
	
	var _StoryTwoTitle2 = _interopRequireDefault(_StoryTwoTitle);
	
	var _StoryTwoExcerpt = __webpack_require__(951);
	
	var _StoryTwoExcerpt2 = _interopRequireDefault(_StoryTwoExcerpt);
	
	var _StoryTwoLearnMoreBtn = __webpack_require__(952);
	
	var _StoryTwoLearnMoreBtn2 = _interopRequireDefault(_StoryTwoLearnMoreBtn);
	
	var _OtherStories = __webpack_require__(941);
	
	var _OtherStories2 = _interopRequireDefault(_OtherStories);
	
	var _OtherStoryTitle = __webpack_require__(944);
	
	var _OtherStoryTitle2 = _interopRequireDefault(_OtherStoryTitle);
	
	var _OtherStoryExcerpt = __webpack_require__(942);
	
	var _OtherStoryExcerpt2 = _interopRequireDefault(_OtherStoryExcerpt);
	
	var _OtherStoryLearnMoreBtn = __webpack_require__(943);
	
	var _OtherStoryLearnMoreBtn2 = _interopRequireDefault(_OtherStoryLearnMoreBtn);
	
	var _StoriesPagination = __webpack_require__(945);
	
	var _StoriesPagination2 = _interopRequireDefault(_StoriesPagination);
	
	var _removeFileExt = __webpack_require__(997);
	
	var _removeFileExt2 = _interopRequireDefault(_removeFileExt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = function styles(theme) {
	  var _storyOneContainer, _storyOnePhotoWrapper, _storyOnePhoto, _storyOneDetailsWrapp, _storyOneDetails, _storyOneTitle, _storyOneExcerpt, _storyTwoContainer, _storyTwoDetailsWrapp, _storyTwoDetails, _storyTwoTitle, _storyTwoExcerpt, _storyTwoPhotoWrapper, _storyTwoPhoto, _learnMoreBtn, _learnMoreBtnInverse, _otherStoriesContaine, _otherStoriesPhoto, _otherStoryDetails, _otherStoryTitle, _otherStoryExcerpt, _otherStoryLearnMoreB;
	
	  return {
	    root: {
	      padding: '15px 0'
	    },
	    introContainer: {
	      position: 'relative',
	      height: '100vh'
	    },
	    storyOneContainer: (_storyOneContainer = {
	      minHeight: 600
	    }, _storyOneContainer[theme.breakpoints.down('sm')] = {
	      paddingTop: 40
	    }, _storyOneContainer[theme.breakpoints.down('xs')] = {
	      padding: 20,
	      height: 'auto'
	    }, _storyOneContainer['& img'] = {
	      transition: 'transform 1.2s !important'
	    }, _storyOneContainer['&:hover'] = {
	      '& img': {
	        transform: 'scale(1.15) rotate(-10deg) !important'
	      }
	    }, _storyOneContainer),
	    storyOnePhotoWrapper: (_storyOnePhotoWrapper = {
	      width: '25%',
	      height: '100%',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'flex-end'
	    }, _storyOnePhotoWrapper[theme.breakpoints.down('sm')] = {
	      width: '100%',
	      height: 'auto',
	      justifyContent: 'center'
	    }, _storyOnePhotoWrapper),
	    storyOnePhoto: (_storyOnePhoto = {
	      borderRadius: '50%',
	      objectFit: 'cover',
	      margin: 'auto',
	      width: 320,
	      height: 320
	    }, _storyOnePhoto[theme.breakpoints.down('md')] = {
	      width: 260,
	      height: 260
	    }, _storyOnePhoto[theme.breakpoints.down('sm')] = {
	      width: 320,
	      height: 320
	    }, _storyOnePhoto[theme.breakpoints.down('xs')] = {
	      width: 220,
	      height: 220
	    }, _storyOnePhoto),
	    storyOneDetailsWrapper: (_storyOneDetailsWrapp = {
	      width: '60%',
	      height: '100%',
	      display: 'flex',
	      alignItems: 'center'
	    }, _storyOneDetailsWrapp[theme.breakpoints.down('sm')] = {
	      width: '100%'
	    }, _storyOneDetailsWrapp[theme.breakpoints.down('xs')] = {
	      height: 'auto',
	      display: 'block'
	    }, _storyOneDetailsWrapp),
	    storyOneDetails: (_storyOneDetails = {
	      padding: 30,
	      maxWidth: 1000
	    }, _storyOneDetails[theme.breakpoints.down('xs')] = {
	      padding: 10
	    }, _storyOneDetails),
	    storyOneTitle: (_storyOneTitle = {
	      textTransform: 'none',
	      fontSize: '1.7em',
	      fontWeight: 500
	    }, _storyOneTitle[theme.breakpoints.down('sm')] = {
	      fontSize: '1.4em'
	    }, _storyOneTitle[theme.breakpoints.down('xs')] = {
	      fontSize: '1.2em'
	    }, _storyOneTitle),
	    storyOneExcerpt: (_storyOneExcerpt = {
	      padding: '20px 0',
	      fontSize: '1em',
	      lineHeight: 1.9,
	      fontWeight: 300,
	      color: theme.palette.text.soft
	    }, _storyOneExcerpt[theme.breakpoints.down('sm')] = {
	      fontSize: '0.9em'
	    }, _storyOneExcerpt[theme.breakpoints.down('xs')] = {
	      fontSize: '0.7em'
	    }, _storyOneExcerpt),
	    storyTwoContainer: (_storyTwoContainer = {
	      minHeight: 600,
	      flexDirection: 'row-reverse'
	    }, _storyTwoContainer[theme.breakpoints.down('sm')] = {
	      paddingTop: 40
	    }, _storyTwoContainer[theme.breakpoints.down('xs')] = {
	      padding: 20,
	      height: 'auto'
	    }, _storyTwoContainer['& img'] = {
	      transition: 'transform 1.2s !important'
	    }, _storyTwoContainer['&:hover'] = {
	      '& img': {
	        transform: 'scale(1.15) rotate(-10deg) !important'
	      }
	    }, _storyTwoContainer),
	    storyTwoDetailsWrapper: (_storyTwoDetailsWrapp = {
	      width: '65%',
	      height: '100%',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'flex-end'
	    }, _storyTwoDetailsWrapp[theme.breakpoints.down('sm')] = {
	      width: '100%'
	    }, _storyTwoDetailsWrapp[theme.breakpoints.down('xs')] = {
	      height: 'auto',
	      display: 'block'
	    }, _storyTwoDetailsWrapp),
	    storyTwoDetails: (_storyTwoDetails = {
	      padding: '30px 0 30px 70px',
	      maxWidth: 900
	    }, _storyTwoDetails[theme.breakpoints.down('sm')] = {
	      padding: 30
	    }, _storyTwoDetails[theme.breakpoints.down('xs')] = {
	      padding: 10
	    }, _storyTwoDetails),
	    storyTwoTitle: (_storyTwoTitle = {
	      textTransform: 'none',
	      color: '#fff',
	      fontSize: '1.7em',
	      fontWeight: 500
	    }, _storyTwoTitle[theme.breakpoints.down('sm')] = {
	      fontSize: '1.4em'
	    }, _storyTwoTitle[theme.breakpoints.down('xs')] = {
	      fontSize: '1.2em'
	    }, _storyTwoTitle),
	    storyTwoExcerpt: (_storyTwoExcerpt = {
	      padding: '30px 0',
	      fontSize: '1em',
	      lineHeight: 1.9,
	      fontWeight: 300,
	      color: '#cdd9e3'
	    }, _storyTwoExcerpt[theme.breakpoints.down('sm')] = {
	      fontSize: '0.9em'
	    }, _storyTwoExcerpt[theme.breakpoints.down('xs')] = {
	      fontSize: '0.7em'
	    }, _storyTwoExcerpt),
	    storyTwoPhotoWrapper: (_storyTwoPhotoWrapper = {
	      width: '35%',
	      height: '100%',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'flex-start'
	    }, _storyTwoPhotoWrapper[theme.breakpoints.down('sm')] = {
	      width: '100%',
	      height: 'auto',
	      justifyContent: 'center'
	    }, _storyTwoPhotoWrapper),
	    storyTwoPhoto: (_storyTwoPhoto = {
	      borderRadius: '50%',
	      objectFit: 'cover',
	      margin: 'auto',
	      width: 320,
	      height: 320
	    }, _storyTwoPhoto[theme.breakpoints.down('md')] = {
	      width: 260,
	      height: 260
	    }, _storyTwoPhoto[theme.breakpoints.down('sm')] = {
	      width: 320,
	      height: 320
	    }, _storyTwoPhoto[theme.breakpoints.down('xs')] = {
	      width: 220,
	      height: 220
	    }, _storyTwoPhoto),
	    learnMoreBtn: (_learnMoreBtn = {
	      transition: 'background 0.7s, color 0.7s'
	    }, _learnMoreBtn[theme.breakpoints.down('sm')] = {
	      fontSize: '0.8em'
	    }, _learnMoreBtn[theme.breakpoints.down('xs')] = {
	      fontSize: '0.7em',
	      width: '100%'
	    }, _learnMoreBtn['&:hover'] = {
	      background: theme.palette.primary.dark,
	      color: '#fff'
	    }, _learnMoreBtn),
	    learnMoreBtnInverse: (_learnMoreBtnInverse = {
	      background: theme.palette.secondary.main,
	      color: '#fff',
	      transition: 'background 0.7s, color 0.7s'
	    }, _learnMoreBtnInverse[theme.breakpoints.down('sm')] = {
	      fontSize: '0.8em'
	    }, _learnMoreBtnInverse[theme.breakpoints.down('xs')] = {
	      fontSize: '0.7em',
	      width: '100%'
	    }, _learnMoreBtnInverse['&:hover'] = {
	      background: theme.palette.secondary.dark
	    }, _learnMoreBtnInverse),
	    otherStoriesContainer: (_otherStoriesContaine = {
	      padding: '70px 50px 0'
	    }, _otherStoriesContaine[theme.breakpoints.down('sm')] = {
	      padding: '40px 0 0'
	    }, _otherStoriesContaine),
	    inspirationalQuote: {
	      fontStyle: 'italic',
	      color: theme.palette.text.light,
	      fontWeight: 300
	    },
	    otherStoriesPhoto: (_otherStoriesPhoto = {
	      borderRadius: '50%',
	      objectFit: 'cover',
	      width: 320,
	      height: 320,
	      margin: 'auto',
	      display: 'block'
	    }, _otherStoriesPhoto[theme.breakpoints.down('md')] = {
	      width: 260,
	      height: 260
	    }, _otherStoriesPhoto[theme.breakpoints.down('sm')] = {
	      width: 320,
	      height: 320
	    }, _otherStoriesPhoto[theme.breakpoints.down('xs')] = {
	      width: 220,
	      height: 220
	    }, _otherStoriesPhoto['& img'] = {
	      transition: 'transform 1.2s !important'
	    }, _otherStoriesPhoto['&:hover'] = {
	      '& img': {
	        transform: 'scale(1.15) rotate(-10deg) !important'
	      }
	    }, _otherStoriesPhoto),
	    otherStoryDetails: (_otherStoryDetails = {
	      padding: '30px 70px 70px 70px',
	      textAlign: 'center'
	    }, _otherStoryDetails[theme.breakpoints.down('md')] = {
	      padding: 30
	    }, _otherStoryDetails[theme.breakpoints.down('xs')] = {
	      textAlign: 'left'
	    }, _otherStoryDetails),
	    otherStoryTitle: (_otherStoryTitle = {
	      textTransform: 'none',
	      fontSize: '1.3em',
	      fontWeight: 500
	    }, _otherStoryTitle[theme.breakpoints.down('sm')] = {
	      fontSize: '1em'
	    }, _otherStoryTitle[theme.breakpoints.down('xs')] = {
	      fontSize: '1.2em'
	    }, _otherStoryTitle),
	    otherStoryExcerpt: (_otherStoryExcerpt = {
	      padding: '20px 0',
	      fontSize: '0.9em',
	      lineHeight: 1.9,
	      fontWeight: 300,
	      color: theme.palette.text.soft,
	      maxHeight: 187,
	      overflow: 'hidden'
	    }, _otherStoryExcerpt[theme.breakpoints.down('sm')] = {
	      fontSize: '0.9em'
	    }, _otherStoryExcerpt[theme.breakpoints.down('xs')] = {
	      fontSize: '0.7em'
	    }, _otherStoryExcerpt),
	    otherStoryLearnMoreBtn: (_otherStoryLearnMoreB = {
	      transition: 'background 0.7s, color 0.7s'
	    }, _otherStoryLearnMoreB[theme.breakpoints.down('sm')] = {
	      fontSize: '0.6em'
	    }, _otherStoryLearnMoreB[theme.breakpoints.down('xs')] = {
	      fontSize: '0.6em',
	      width: '100%'
	    }, _otherStoryLearnMoreB['&:hover'] = {
	      background: theme.palette.primary.dark,
	      color: '#fff'
	    }, _otherStoryLearnMoreB)
	  };
	};
	
	var StoriesPage = function StoriesPage(_ref) {
	  var classes = _ref.classes,
	      theme = _ref.theme,
	      data = _ref.data,
	      pathContext = _ref.pathContext;
	  var siteMetadata = data.site.siteMetadata,
	      banner = data.imageSharp,
	      thumbnails = data.allImageSharp.edges;
	  var group = pathContext.group,
	      index = pathContext.index,
	      pageCount = pathContext.pageCount;
	
	
	  var thumbnailSizes = thumbnails.reduce(function (acc, _ref2) {
	    var node = _ref2.node;
	
	    var _node$sizes = node.sizes,
	        originalName = _node$sizes.originalName,
	        rest = _objectWithoutProperties(_node$sizes, ['originalName']);
	
	    var originalNameWithoutExt = (0, _removeFileExt2.default)(originalName);
	
	    if (!acc[originalNameWithoutExt]) {
	      acc[originalNameWithoutExt] = rest;
	    }
	    return acc;
	  }, {});
	
	  var orderedStories = group.sort(function (a, b) {
	    var dateA = (0, _moment2.default)(a.frontmatter.date);
	    var dateB = (0, _moment2.default)(b.frontmatter.date);
	    if (dateA.isAfter(dateB)) return -1;
	    if (dateA.isBefore(dateB)) return 1;
	    return 0;
	  });
	
	  var storyOne = orderedStories[0];
	  var storyTwo = orderedStories[1];
	  var otherStories = orderedStories.slice(2);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Meta.RootMeta, {
	      url: siteMetadata.siteUrl + '/weight-loss-stories',
	      title: siteMetadata.siteTitle + ' | ' + 'Real Life Weight Loss Success Stories From Real People',
	      description: 'Real life success stories shared by people who\'ve been successful achieving their weight loss goal(s). These are inspirational stories from people who have done the almost-impossible by taking action and making it all happen by willpower, positive thinking, mindset and determination.',
	      breadCrumb: [{
	        url: siteMetadata.siteUrl + '/weight-loss-stories',
	        name: 'Weight-Loss-Stories'
	      }]
	    }),
	    _react2.default.createElement(_Intro2.default, {
	      wrapperClassName: classes.introContainer,
	      gatsbyImage: _react2.default.createElement(_gatsbyImage2.default, {
	        style: { height: '100vh' },
	        imgStyle: { height: '100vh' },
	        sizes: banner.sizes,
	        alt: 'Real life success stories shared by people who lost weight',
	        title: 'Real life success stories shared by people who lost weight'
	      }),
	      inspirationalQuote: '"Will Is A Skill" - Charushila Biswas'
	    }),
	    !storyOne && !storyTwo && !otherStories && _react2.default.createElement(
	      _Typography2.default,
	      { variant: 'display1', align: 'center', style: { padding: 20 } },
	      'No stories available.'
	    ),
	    storyOne && _react2.default.createElement(
	      _reactLazyload2.default,
	      { height: 200 },
	      _react2.default.createElement(_StoryOne2.default, {
	        className: classes.storyOneContainer,
	        leftClassName: classes.storyOnePhotoWrapper,
	        rightClassName: classes.storyOneDetailsWrapper,
	        left: _react2.default.createElement(_gatsbyImage2.default, {
	          className: classes.storyOnePhoto,
	          sizes: thumbnailSizes['st_' + storyOne.frontmatter.date],
	          alt: storyOne.frontmatter.title,
	          title: storyOne.frontmatter.title
	        }),
	        right: _react2.default.createElement(
	          'div',
	          { className: classes.storyOneDetails },
	          _react2.default.createElement(_StoryOneTitle2.default, {
	            className: classes.storyOneTitle,
	            text: storyOne.frontmatter.title
	          }),
	          _react2.default.createElement(_StoryOneExcerpt2.default, {
	            className: classes.storyOneExcerpt,
	            text: storyOne.excerpt
	          }),
	          _react2.default.createElement(_StoryOneLearnMoreBtn2.default, {
	            url: storyOne.fields.slug,
	            btnClassName: classes.learnMoreBtn,
	            text: 'Learn More'
	          })
	        )
	      })
	    ),
	    storyTwo && _react2.default.createElement(_StoryTwo2.default, {
	      className: classes.storyTwoContainer,
	      leftClassName: classes.storyTwoDetailsWrapper,
	      rightClassName: classes.storyTwoPhotoWrapper,
	      style: { background: theme.palette.primary.main },
	      left: _react2.default.createElement(
	        'div',
	        { className: classes.storyTwoDetails },
	        _react2.default.createElement(_StoryTwoTitle2.default, {
	          className: classes.storyTwoTitle,
	          text: storyTwo.frontmatter.title
	        }),
	        _react2.default.createElement(_StoryTwoExcerpt2.default, {
	          className: classes.storyTwoExcerpt,
	          text: storyTwo.excerpt
	        }),
	        _react2.default.createElement(_StoryTwoLearnMoreBtn2.default, {
	          url: storyTwo.fields.slug,
	          btnClassName: classes.learnMoreBtnInverse,
	          text: 'Learn More'
	        })
	      ),
	      right: _react2.default.createElement(_gatsbyImage2.default, {
	        className: classes.storyTwoPhoto,
	        sizes: thumbnailSizes['st_' + storyTwo.frontmatter.date],
	        alt: storyTwo.frontmatter.title,
	        title: storyTwo.frontmatter.title
	      })
	    }),
	    otherStories && otherStories.length && _react2.default.createElement(_OtherStories2.default, {
	      className: classes.otherStoriesContainer,
	      header: _react2.default.createElement(
	        _Typography2.default,
	        { variant: 'display1', align: 'center' },
	        'Other Stories'
	      ),
	      inspirationalQuote: _react2.default.createElement(
	        _Typography2.default,
	        {
	          variant: 'title',
	          align: 'center',
	          classes: { root: classes.inspirationalQuote }
	        },
	        'If you are tired of starting over, stop giving up'
	      ),
	      render: function render(Story) {
	        return otherStories.map(function (node, i) {
	          return _react2.default.createElement(Story, {
	            key: node.frontmatter.pageType + i,
	            top: _react2.default.createElement(_gatsbyImage2.default, {
	              className: classes.otherStoriesPhoto,
	              sizes: thumbnailSizes['st_' + node.frontmatter.date],
	              alt: node.frontmatter.title,
	              title: node.frontmatter.title
	            }),
	            bottom: _react2.default.createElement(
	              'div',
	              { className: classes.otherStoryDetails },
	              _react2.default.createElement(_OtherStoryTitle2.default, {
	                className: classes.otherStoryTitle,
	                text: node.frontmatter.title
	              }),
	              _react2.default.createElement(_OtherStoryExcerpt2.default, {
	                className: classes.otherStoryExcerpt,
	                text: node.excerpt
	              }),
	              _react2.default.createElement(_OtherStoryLearnMoreBtn2.default, {
	                btnClassName: classes.otherStoryLearnMoreBtn,
	                url: node.fields.slug,
	                text: 'Learn More'
	              })
	            )
	          });
	        });
	      }
	    }),
	    _react2.default.createElement(_StoriesPagination2.default, {
	      currentPage: index,
	      totalItems: group.length * pageCount,
	      itemsPerPage: group.length,
	      prefix: '/weight-loss-stories'
	    }),
	    _react2.default.createElement('div', { style: { padding: 20 } })
	  );
	};
	
	StoriesPage.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.shape({
	    group: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      excerpt: _propTypes2.default.string,
	      fields: _propTypes2.default.object,
	      fileAbsolutePath: _propTypes2.default.string,
	      frontmatter: _propTypes2.default.shape({
	        date: _propTypes2.default.string,
	        pageType: _propTypes2.default.string,
	        shortDescription: _propTypes2.default.string,
	        source: _propTypes2.default.string,
	        thumbnail: _propTypes2.default.string, // not using atm
	        tags: _propTypes2.default.arrayOf(_propTypes2.default.string),
	        title: _propTypes2.default.string
	      }),
	      html: _propTypes2.default.string,
	      id: _propTypes2.default.string,
	      timeToRead: _propTypes2.default.number
	    })),
	    index: _propTypes2.default.number,
	    pageCount: _propTypes2.default.number,
	    pathPrefix: _propTypes2.default.string,
	    additionalContext: _propTypes2.default.object
	  })
	
	  // prettier-ignore
	  // eslint-disable-next-line
	};var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = (0, _withStyles2.default)(styles, { withTheme: true })(StoriesPage);

/***/ }),

/***/ 997:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function removeFileExt(fileName) {
	  return fileName.slice(0, fileName.search(/\.[a-zA-Z0-9]+$/));
	}
	
	exports.default = removeFileExt;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-stories-js-a77e5dec55a98838336c.js